import { writable } from 'svelte/store';

export const languages = writable([
    "eng"
])

export const modal = writable(null)